import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Loader from "react-loader";
import {fetchedPage, loadPage} from "../../actions/page";
import Title from "../elements/Title";
import HeroImage from "../elements/HeroImage";
import BlockLoop from "../elements/BlockLoop";
import Resources from "../elements/Resources";
import MissingPage from "../elements/MissingPage"
import TopBar from "../layout/TopBar";
import TopNavigation from "../navigation/TopNavigation";
import Footer from "../layout/Footer";
import SideBar from "../navigation/SideBar";


class GenericPage extends React.Component {
    constructor(props) {
        //IMPLEMENT OTHER JUNK HERE
        super(props)
        this.state = {
            missing: false
        }
    }

    componentWillUnmount() {
        this.props.loadPage()
    }
    componentDidMount() {

        this.props.fetchedPage('/api/generic/' + this.props.location.pathname).then(res => this.setState({missing: false})).catch(
          res => this.setState({missing: true})
        );
    }

    componentDidUpdate(prevProps) {

        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.props.loadPage()
            this.props.fetchedPage('/api/generic/' + this.props.location.pathname).then(res => this.setState({missing: false})).catch(
              res => this.setState({missing: true})
            );
        }
    }

    isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }


    render() {
        const {page, modal, navigation, loaded} = this.props;
        if (this.state.missing === true) {
            return(
            <Loader loaded={true}>
                <div>
                    <div className={modal.activeClass === false ? "rob" : "rob rob__blur"}>
                        <TopBar/>
                        <TopNavigation/>
                        <SideBar navigation={navigation}/>
                        <MissingPage url={'/assets/general/Placeholder.png'} title={'PlaceHolder'}/>
                        <Footer/>
                    </div>
                </div>
            </Loader>
            )
        }


        let quotation;
        if (this.isEmpty(page.resources)) {
            quotation = <div className="row">
                <div className={"col-md-12"}>
                    <BlockLoop/>
                </div>
            </div>;
        } else {
            quotation = <div className="row">
                <div className={"container"}>
                    <div className="row">
                    <div className={"col-md-8"}>
                        <BlockLoop/>
                    </div>
                    <div className={"col-md-4"}>
                        <Resources resources={page.resources}/>
                    </div>
                    </div>
                </div>
            </div>;
        }

        return (
          <Loader loaded={loaded}>
          <div>
              <div className={modal.activeClass === false ? "rob" : "rob rob__blur"}>
                  <TopBar/>
                  <TopNavigation/>
                  <SideBar navigation={navigation}/>
                  <HeroImage {...page.heroImage}  />
                  <Title introTitle={page.title}/>
                  {quotation}
                  <Footer/>
              </div>
          </div>
          </Loader>
        )
    };

}

GenericPage.propTypes = {
    fetchedPage: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        page: state.page,
        loaded: state.loaded.loaded,
        modal: state.modal,
        navigation: state.navigation
    };
}

export default connect(mapStateToProps, {fetchedPage, loadPage})(GenericPage);




// WEBPACK FOOTER //
// ./src/components/pages/GenericPage.js